//actions.js

export function globalAction(type, payload) {
  return {
      type,
      payload
  }
}

